<template>
  <div class="wrap" :style="{backgroundColor: activityConfig.bgColor}" v-wechat-title="$route.meta.title=activityConfig.pageTitle">
    <template v-if="hasPwdTemp">
      <top-img :imgUrl="pwdTempMainData.options.imgUrl" :height="pwdTempMainData.h5Options.topImgHeight"/>
      <main-action
          :options="pwdTempMainData.options"
          :btnImgUrl="pwdTempMainData.h5Options.imgUrl"
          :btnText="pwdTempMainData.h5Options.text"
          :btnBgColor="pwdTempMainData.h5Options.btnBgColor"
      />
      <sub-list v-for="sub in pwdTempSubDatas" :key="sub.key" :list="sub.children" :h5Options="sub.h5Options" />
      <poster-modal/>
      <copy-modal/>
      <red-bag
          v-if="activityConfig.hasRedBag === 1"
          :pwd="pwdTempMainData.options.pwd"
          :url="pwdTempMainData.options.url"
          :copyTemp="activityConfig.mainCopyTemp"
      />
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import TopImg from '@/components/activeComp/TopImg'
import MainAction from '@/components/activeComp/MainAction'
import SubList from '@/components/activeComp/SubList'
import RedBag from '@/components/activeComp/RedBag'
import PosterModal from '@/components/common/PosterModal'
import CopyModal from '@/components/common/CopyModal'
import { mapState, mapGetters, mapMutations ,mapActions } from 'vuex'
import * as activityServices from '@/services/activity'
import * as types from '../store/types'
import { goLogin } from '@/utils/hybrid'


export default {
  name: 'Home',
  components: {
    TopImg,
    MainAction,
    SubList,
    PosterModal,
    CopyModal,
    RedBag,
  },
  data () {
    return {
      key: this.$route.query.key || '',
      qPid: this.$route.query.pid || '',
    }
  },
  computed: {
    ...mapState([
      'pwdTempData',
      'activityConfig',
      'userInfo'
    ]),
    ...mapGetters([
      'hasPwdTemp',
      'pwdTempMainData',
      'pwdTempSubDatas',
    ])
  },
  methods: {
    ...mapMutations([
      types.SET_PWD_TEMP,
      types.SET_ACTIVITY_CONFIG,
      types.SET_MAIN_ACT,
    ]),
    ...mapActions([
      'getDeviceInfo',
      'getShareDomain',
      'getUserConfig',
      'combinePoster',
      'getUserInfo',
    ]),
    async getTemp () {
      const params = {
        pid: this.userInfo.pid,
        relationId: this.userInfo.relationId,
        key: this.key,
      }
      if (!params.pid) {
        this.$toast.show('请在悦惠APP中打开!')
        return
      }
      const res = await activityServices.getH5Page(this.key)
      const data = JSON.parse(res.data.content);
      this[types.SET_PWD_TEMP](data)
      this[types.SET_ACTIVITY_CONFIG](data.h5Options)
      this.$route.meta.title = data.h5Options.pageTitle

      const params2 = {
        pid: this.userInfo.pid,
        relationId: this.userInfo.relationId,
        activityId: this.pwdTempMainData.options.activityId,
        title: this.pwdTempMainData.options.title,
        imageUrl: this.pwdTempMainData.options.imgUrl
      };
      const res2 = await activityServices.getActivityRes(params2);
      if (res2.status === 1) {
        this[types.SET_MAIN_ACT](res2.data)
      }
    },
    async init () {
      await this.getDeviceInfo()
      await this.getShareDomain()
      const userInfo = await this.getUserInfo();
      if ((!userInfo || !userInfo.agentId) && !this.qPid) {
        this.$toast.show('请登录悦惠APP!')
        goLogin();
        return null;
      }
      await this.getUserConfig({...this.$route.query, scene: 'activity'});
      await this.getTemp()
      await this.combinePoster()
      
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped lang="less">
  .wrap {
    min-height: 100vh;
    padding-bottom: 1rem;
  }
</style>
